import { Component, OnInit, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { ChangeUserStatus, EntrenamientoDiaIndividual, EntrenamientoModelBroken, Level, Personal, PersonalTrainer, Training} from '../../../api/interfaces/user';
import { ImageService } from '../../../api/services/image/image.service';
import { TrainingTypeEnum } from '../../../enums/training-type';
import { StatusEnum } from '../../../enums/status';
import {MatDialog} from '@angular/material/dialog';
import { AssignDialogComponent } from '../assign-dialog/assign-dialog.component';
import { FormControl, FormGroup } from '@angular/forms';
import { SnackbarService } from '../../../utils/snackbar/snackbar.service';
import { TrainingService } from '../../../api/services/training/training.service';
import { GenericDialogComponent } from '../../generic-dialog/generic-dialog.component';
import { UserService } from '../../../api/services/user/user.service';
import { MobileDetectorService } from '../../../services/mobileDetector/mobile-detector.service';
import { PlanDatosDia } from '../../../api/interfaces/plans';
import { RegisterService } from '../../../api/services/register/register.service';
import { TrainingDays } from '../../../api/interfaces/register';
import { SharedDataService } from 'src/app/services/sharedData/shared-data.service';
import { DomSanitizer } from '@angular/platform-browser';
import { saveAs } from 'file-saver';
import { ResendMailComponent } from '../resend-mail/resend-mail.component';
@Component({
  selector: 'app-profile-header',
  templateUrl: './profile-header.component.html',
  styleUrls: ['./profile-header.component.scss']
})
export class ProfileHeaderComponent implements OnInit {

  userHasImage: boolean = false;
  isMobile: boolean = false;
  isValid: boolean = false;
  @Input('avatarUrl') avatarUrl: string;
  TrainingTypeEnum = TrainingTypeEnum;
  StatusEnum = StatusEnum;
  ADMIN_ID : number = 1;
  showLevel: boolean = false;

  groups: TrainingDays[] = [];
  
  @Input('disableSave') disableSave: boolean;
  @Input('training') training: Training;
  @Input('personalData') personalData: Personal;
  @Input('user_id') user_id: number;
  @Input('isAdmin') isAdmin: boolean;
  @Input('isStudent') isStudent: boolean;
  @Input('status') status: string;
  @Input('datosTraining') datosTraining: EntrenamientoModelBroken;
  @Input('usuarioId') usuarioId: number;
  @Input('email') email: string;
  
  @ViewChild('levelSelect') levelSelect;
  @ViewChild('trainerSelect') trainerSelect;
  @Output() updateDataEvent = new EventEmitter<any>();

  levels: Level[] = [];
  trainers: PersonalTrainer[] = [];

  userForm = new FormGroup({
    level: new FormControl(),
    trainer: new FormControl(),
    group: new FormControl()
  });

  name = 'Test display image';
  thumbnail: any;

  constructor(
    private imageService: ImageService,
    public dialog: MatDialog,
    private snack: SnackbarService,
    private trainingService: TrainingService,
    private userService: UserService,
    private mobileDetectorService: MobileDetectorService,
    private registerService: RegisterService,
    private sharedData: SharedDataService,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit(): void {
    this.getAvatar();
    this.isMobile = this.mobileDetectorService.isMobile();
    if(this.avatarUrl != null) {
      this.userHasImage = true;
    }
    this.loadLevels();
    this.loadTrainers();
    this.loadGroups();
    this.userForm.patchValue({level: this.training.level});
    this.userForm.patchValue({trainer: this.training.trainer});
    this.userForm.patchValue({group: this.datosTraining.grupo});
    this.checkValidSaveButton();
  }

  async selectFiles(event) {
    if(!this.isAdmin) {
      try {
        await this.imageService.uploadFile(event);
        this.getAvatar();
      } catch {
        this.avatarUrl="";
        this.userHasImage = false;
      }
    }
  }

  async getAvatar() {
    this.avatarUrl = await this.imageService.getAvatarUrl(this.usuarioId);
    if(this.avatarUrl) {
      this.userHasImage = true;
    }
  }

  openDialog(){
    const dialogRef = this.dialog.open(AssignDialogComponent);

    dialogRef.afterClosed().subscribe(result => {
      //api call
    });
  }

  loadGroups() {
    this.registerService.getTrainingDays().subscribe( response=> {
      this.groups = response;
      this.groups.splice(0,1);
    },
    error => {
      console.error(error);
    });
  }

  loadLevels() {
    this.trainingService.getLevels().subscribe( response=> {
      this.levels = response;
      let remover: number = this.levels.findIndex(option => option.id == 1);
      if(remover != -1) {
        this.levels.splice(remover, 1);
      }
    },
    error => {
      console.error(error);
    });
  }

  loadTrainers() {
    this.trainingService.getTrainers().subscribe( response=> {
      this.trainers = response;
    },
    error => {
      console.error(error);
    });
  }

  openLevelSelect() {
    this.levelSelect.open();
    // this.showLevel = true;
  }

  openTrainerSelect() {
    this.trainerSelect.open();
  }

  saveLevel(level: Level) {
    this.userForm.patchValue({level: level});
    this.checkValidSaveButton();
  }

  saveTrainer(trainer: PersonalTrainer) {
    this.userForm.patchValue({trainer: trainer});
    this.checkValidSaveButton();
  }

  saveGroup(group: TrainingDays) {
    this.userForm.patchValue({group: group});
    this.checkValidSaveButton();
  }

  openSaveDialog() {
    const entrenamientoDiasPlan: PlanDatosDia[] = JSON.parse(sessionStorage.getItem('entrenamientoDiasPlan'));
    let text: string = "";
    if(entrenamientoDiasPlan) {
      const entrenamientoDiasPlanAdicionales: PlanDatosDia[] = entrenamientoDiasPlan.filter(dia => (dia.tipoDia == 'A' && dia.detalleDia == 'Descanso'));
      if(entrenamientoDiasPlanAdicionales.length > 0) {
        text = "Hay uno o varios días donde el alumno indicó su disponibilidad y no fueron completados.";
      }
    }

    const dialogRef = this.dialog.open(GenericDialogComponent, {
      data: {
        title: "¿Desea activar al alumno?",
        iconClass: "bigBlueIcon",
        text: text,
        icon: "error_outlined",
        confirm: "SI, ACTIVAR",
        cancel: "NO"
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      let today = new Date().toISOString();
      if(result) {
        const entrenadorId: number = this.userForm.value.trainer.id;
        const entrenamientoNivelId: number = this.userForm.value.level.id;
        const entrenamientoGrupoId: number = this.userForm.value.group.entrenamientoGrupoId ? this.userForm.value.group.entrenamientoGrupoId:  this.datosTraining.idGrupo;
        let changeUserStatus: ChangeUserStatus = {
          entrenamientoNivelId: entrenamientoNivelId,
          entrenadorId: entrenadorId,
          entrenamientoGrupoId: entrenamientoGrupoId,
          estado: "A",
          ultimaModificacion: today,
          ultimaModificacionPor: this.ADMIN_ID,
        };
        this.userService.changeUserStatus(changeUserStatus, this.user_id).subscribe(response => {
          this.snack.snackTranslate('snacks.sucess.updatingData.activate');
          this.afterSubmit();
        },
        error => {
          console.error(error);
          this.snack.snackTranslate('snacks.error.activate');
        })
      }
    });
  }

  afterSubmit() {
    this.updateDataEvent.emit();
    this.isValid = false;
    sessionStorage.setItem('alumnoIdCheck',this.user_id.toString());
    this.sharedData.changeMessage("reloadWeek2");
  }

  openEditDialog() {

    const dialogRef = this.dialog.open(GenericDialogComponent, {
      data: {
        title: "¿Desea guardar los cambios?",
        iconClass: "bigBlueIcon",
        text: "",
        icon: "error_outlined",
        confirm: "SI",
        cancel: "NO",
        showConfirmAsPrimary: true
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      let today = new Date().toISOString();
      if(result) {
        const entrenadorId: number = this.userForm.value.trainer.id;
        const entrenamientoNivelId: number = this.userForm.value.level.id;
        const entrenamientoGrupoId: number = this.userForm.value.group.entrenamientoGrupoId ? this.userForm.value.group.entrenamientoGrupoId:  this.datosTraining.idGrupo;
        const changeUserStatus: ChangeUserStatus = {
          entrenamientoNivelId: entrenamientoNivelId,
          entrenadorId: entrenadorId,
          entrenamientoGrupoId: entrenamientoGrupoId,
          estado: null,
          ultimaModificacion: today,
          ultimaModificacionPor: this.ADMIN_ID,
        };
        this.userService.changeUserStatus(changeUserStatus, this.user_id).subscribe(response => {
          this.snack.snackTranslate('snacks.sucess.updatingData.generic');
          this.afterSubmit();
        },
        error => {
          console.error(error);
          this.snack.snackTranslate('snacks.error.trainingDataPatch');
        })
      }
    });
  }

  checkValidSaveButton() {
    const {level, trainer, group} = this.userForm.getRawValue();
    if( level.id != 1 && trainer && group ) {
      this.isValid = true;
    } else {
      this.isValid = false;
    }
  }  

  openResendMailDialog() {
    this.dialog.open(ResendMailComponent, {
      data: {
        email: this.email
      }
    });
  }

}
